import { combineReducers } from 'redux'
import form from './form'

const campersReducer = combineReducers({
  form
})

export default campersReducer
